module.exports = __webpack_public_path__ + "img/meituan.c32a1774.png";